/**
 * Подписи подразделений и порядок вкладок.
 *
 * Источник — справочник подразделений (departments.list): администратор
 * заводит новые и переименовывает прежние. Константы ниже — запасной
 * вариант на время загрузки справочника и для базовых ОА, ООА, ОАП.
 */

import { DepartmentCode } from "@taskflow/contracts";
import { useMemo } from "react";

import { departmentTree, useDepartmentsQuery } from "../directory/api";

export const DEPARTMENT_LABELS: Record<string, string> = {
  [DepartmentCode.OA]: "ОА",
  [DepartmentCode.OOA]: "ООА",
  [DepartmentCode.OAP]: "ОАП",
};

export const DEPARTMENT_ORDER: string[] = [DepartmentCode.OA, DepartmentCode.OOA, DepartmentCode.OAP];

export interface DepartmentTabs {
  /** Коды в порядке дерева: вышестоящее, за ним подчинённые. */
  order: string[];
  /** Код → название. */
  labels: Record<string, string>;
  /** Код → глубина в дереве (0 — верхний уровень). */
  depth: Record<string, number>;
}

/** Порядок и подписи вкладок подразделений — из справочника. */
export function useDepartmentTabs(): DepartmentTabs {
  const departments = useDepartmentsQuery();
  return useMemo(() => {
    const items = departments.data?.data;
    if (items === undefined || items.length === 0) {
      return {
        order: DEPARTMENT_ORDER,
        labels: DEPARTMENT_LABELS,
        depth: {},
      };
    }
    const tree = departmentTree(items);
    return {
      order: tree.map((item) => item.code),
      labels: { ...DEPARTMENT_LABELS, ...Object.fromEntries(tree.map((item) => [item.code, item.name])) },
      depth: Object.fromEntries(tree.map((item) => [item.code, item.depth])),
    };
  }, [departments.data]);
}
